import { useState } from 'react';
import { LogOut, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { useAuthStore } from '@/core/auth/authStore';
import { authApi } from '@/core/auth/authApi';
import { env } from '@/core/config/env';
import { useUiStore } from '@/core/ui/uiStore';
import { ConfirmDialog } from '@/components/ConfirmDialog';

export function TopBar() {
  const role = useAuthStore((s) => s.role);
  const clear = useAuthStore((s) => s.clear);
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);
  // Confirm before logging out — an accidental click costs an OTP to get back in.
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const onLogout = async () => {
    setLoggingOut(true);
    try {
      await authApi.logout();
    } catch {
      // ignore network/logout errors; clear the session regardless
    }
    clear();
    window.location.href = '/login';
  };

  return (
    <header className="flex h-14 items-center justify-between border-b border-fv-border bg-white px-4 md:px-6">
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          className="rounded-lg p-1.5 text-fv-muted transition-colors hover:bg-fv-surfaceLow hover:text-fv-text"
        >
          {collapsed ? <PanelLeftOpen size={18} /> : <PanelLeftClose size={18} />}
        </button>
        <span className="text-sm text-fv-muted">Food Valve Admin Console</span>
      </div>
      <div className="flex items-center gap-4">
        {env.appEnv !== 'production' && (
          <span className="rounded-full bg-fv-orange/15 px-2 py-0.5 text-xs font-semibold text-fv-orange">
            {env.appEnv}
          </span>
        )}
        <span className="rounded-full bg-fv-primary/10 px-2.5 py-0.5 text-xs font-semibold text-fv-primary">
          {role ?? '—'}
        </span>
        <button
          onClick={() => setConfirmOpen(true)}
          className="flex items-center gap-1.5 text-sm text-fv-muted transition-colors hover:text-fv-error"
        >
          <LogOut size={16} /> Logout
        </button>
      </div>
      <ConfirmDialog
        open={confirmOpen}
        title="Logout"
        message="Are you sure you want to log out of the admin console?"
        confirmLabel="Logout"
        danger
        loading={loggingOut}
        onConfirm={onLogout}
        onCancel={() => setConfirmOpen(false)}
      />
    </header>
  );
}
